var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5005 0.656036H10.563C10.4943 0.656036 10.438 0.712286 10.438 0.781036V8.87479H2.84425V7.73416C2.84425 7.62947 2.72237 7.5701 2.64112 7.63573L0.423937 9.38573C0.408997 9.39742 0.396914 9.41236 0.388605 9.42941C0.380295 9.44647 0.375977 9.46519 0.375977 9.48416C0.375977 9.50313 0.380295 9.52186 0.388605 9.53891C0.396914 9.55597 0.408997 9.57091 0.423937 9.5826L2.64112 11.3326C2.72394 11.3982 2.84425 11.3389 2.84425 11.2342V10.0623H10.6255C11.1771 10.0623 11.6255 9.61385 11.6255 9.06229V0.781036C11.6255 0.712286 11.5693 0.656036 11.5005 0.656036Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyIcon);
export default __webpack_public_path__ + "static/media/applyIcon.41afc0f1ab1e4a10c2730762757e49c3.svg";
export { ForwardRef as ReactComponent };